import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Column } from 'further-ui/components/Layout';
import { HoldingClassRealisations } from './types';
import ManualConsiderationCard from './ManualConsiderationCard';

type ManualConsiderationFormProps = {
  currencyCode: CurrencyCode;
  disabled: boolean;
};

const ManualConsiderationForm: React.FC<ManualConsiderationFormProps> = ({
  currencyCode,
  disabled,
}) => {
  const { control, getValues } =
    useFormContext<rules.CreateRealisationFormValues>();

  const holdingClassRealisations: HoldingClassRealisations = getValues(
    'holdingClassRealisation',
  );

  return (
    <Column spacing="lg">
      {holdingClassRealisations.map((holdingClass, index) => (
        <ManualConsiderationCard
          key={holdingClass.holdingClassId}
          control={control}
          index={index}
          name={holdingClass.name}
          unitsSold={holdingClass.unitsSold ?? 0}
          currencyCode={currencyCode}
          disabled={disabled}
        />
      ))}
    </Column>
  );
};

export default ManualConsiderationForm;
